<template>
  <SliderForm action="create" />
</template>

<script>
import SliderForm from '@/components/Slider/SliderForm'

export default {
  components: {
    SliderForm
  }
}
</script>



// WEBPACK FOOTER //
// src/views/slider/Create.vue